import React from "react";
import PaymentReportTable from "./PaymentReportTable";

const PaymentReportList = () => {
  return (
    <div className="row m-0">
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Payment Report</h4>
            <p className="card-subtitle mb-4">
              List of payments from the selected date range.
            </p>
            <PaymentReportTable />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentReportList;
